import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, StatusBadge } from "../components/Common";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from "../components/ui/dialog";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../components/ui/select";
import { Plus, Calendar as CalendarIcon, Trash2 } from "lucide-react";
import { fmtDate } from "../lib/format";
import { toast } from "sonner";

const TIPOS = [["visita", "Visita presencial"], ["reuniao_online", "Reunião online"], ["ligacao", "Ligação"], ["whatsapp", "WhatsApp"], ["email", "E-mail"], ["follow_up", "Follow-up"]];

export default function Agenda() {
  const [list, setList] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ cliente_id: "", tipo: "visita", data: "", horario: "", objetivo: "", status: "agendada" });
  const load = async () => setList((await api.get("/visitas")).data);
  useEffect(() => { load(); api.get("/clientes").then((r) => setClientes(r.data)); }, []);
  const cliente = (id) => clientes.find((c) => c.id === id)?.nome_fantasia || "-";
  const save = async () => { try { await api.post("/visitas", { ...form, data: form.data ? new Date(form.data).toISOString() : new Date().toISOString() }); toast.success("Agendada"); setOpen(false); load(); } catch { toast.error("Erro"); } };
  const del = async (v) => {
    if (!window.confirm(`Excluir esta atividade com ${cliente(v.cliente_id)}?`)) return;
    try { await api.delete(`/visitas/${v.id}`); toast.success("Atividade excluída"); load(); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erro ao excluir"); }
  };

  return (
    <div>
      <PageHeader title="Agenda & Visitas" subtitle="Compromissos comerciais e follow-ups" actions={<Button data-testid="btn-new-visita" onClick={() => setOpen(true)} className="bg-[#075BFF] hover:bg-[#087BFF]"><Plus className="w-4 h-4 mr-1" />Nova atividade</Button>} />
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {list.map((v) => (
          <div key={v.id} className="p-4 bg-white dark:bg-slate-900 rounded-xl border border-slate-200 dark:border-slate-800">
            <div className="flex items-start justify-between gap-2 mb-2">
              <div className="flex items-center gap-2 min-w-0"><CalendarIcon className="w-4 h-4 text-blue-500 shrink-0" /><div className="text-xs text-slate-500 truncate">{fmtDate(v.data)} {v.horario}</div></div>
              <Button data-testid={`btn-del-visita-${v.id}`} variant="ghost" size="sm" onClick={() => del(v)} title="Excluir" className="h-7 w-7 p-0 text-rose-600 hover:text-rose-700 hover:bg-rose-50 dark:hover:bg-rose-500/10"><Trash2 className="w-3.5 h-3.5" /></Button>
            </div>
            <div className="font-semibold text-sm">{cliente(v.cliente_id)}</div>
            <div className="text-xs text-slate-500 mt-1 capitalize">{v.tipo.replace("_", " ")}</div>
            {v.objetivo && <div className="text-sm mt-2">{v.objetivo}</div>}
            <div className="mt-3"><StatusBadge status={v.status} /></div>
          </div>
        ))}
        {list.length === 0 && <div className="col-span-full text-center text-slate-500 py-12">Sem atividades.</div>}
      </div>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent><DialogHeader><DialogTitle>Nova atividade</DialogTitle></DialogHeader>
          <div className="space-y-3">
            <div className="space-y-1"><Label>Cliente</Label><Select value={form.cliente_id} onValueChange={(v) => setForm({ ...form, cliente_id: v })}><SelectTrigger data-testid="v-cliente"><SelectValue placeholder="Selecione..." /></SelectTrigger><SelectContent>{clientes.map((c) => <SelectItem key={c.id} value={c.id}>{c.nome_fantasia || c.razao_social}</SelectItem>)}</SelectContent></Select></div>
            <div className="space-y-1"><Label>Tipo</Label><Select value={form.tipo} onValueChange={(v) => setForm({ ...form, tipo: v })}><SelectTrigger><SelectValue /></SelectTrigger><SelectContent>{TIPOS.map(([k, l]) => <SelectItem key={k} value={k}>{l}</SelectItem>)}</SelectContent></Select></div>
            <div className="grid grid-cols-2 gap-3">
              <div className="space-y-1"><Label>Data</Label><Input type="date" value={form.data?.substring(0, 10) || ""} onChange={(e) => setForm({ ...form, data: e.target.value })} /></div>
              <div className="space-y-1"><Label>Horário</Label><Input type="time" value={form.horario} onChange={(e) => setForm({ ...form, horario: e.target.value })} /></div>
            </div>
            <div className="space-y-1"><Label>Objetivo</Label><Input value={form.objetivo} onChange={(e) => setForm({ ...form, objetivo: e.target.value })} /></div>
          </div>
          <DialogFooter><Button variant="outline" onClick={() => setOpen(false)}>Cancelar</Button><Button data-testid="btn-save-visita" onClick={save} className="bg-[#075BFF] hover:bg-[#087BFF]">Salvar</Button></DialogFooter>
        </DialogContent>
      </Dialog>
    </div>
  );
}
